import { useEffect, useRef, useState } from "react";

function Preview({ data = [], duplicate = false }) {
  const BATCH_SIZE = 50;
  const containerRef = useRef(null);
  const loaderRef = useRef(null);

  const [rows, setRows] = useState(data.slice(0, BATCH_SIZE));
  const columns = Object.keys(data[0] || []);

  useEffect(() => {
    setRows(data.slice(0, BATCH_SIZE));
  }, [data]);

  useEffect(() => {
    const options = {
      root: containerRef.current,
      rootMargin: "20px",
      threshold: 1.0,
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setRows((prevRows) => {
          const nextRows = data.slice(0, prevRows.length + BATCH_SIZE);
          return nextRows;
        });
      }
    }, options);

    if (loaderRef.current) observer.observe(loaderRef.current);

    return () => observer.disconnect();
  }, [data]);

  return (
    <div ref={containerRef} style={{ maxHeight: "50vh", overflowY: "auto" }}>
      {data.length ? (
        <table className="table-auto border-collapse border border-gray-300 w-full">
          <thead>
            <tr className="bg-gray-100 font-bold">
              {columns.map((column) => (
                <th key={column} className="border px-2 py-1">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={`${duplicate ? "bg-red-200 text-red-800" : ""}`}>
            {rows.map(({ imei, device_id, dispatch_date }) => (
              <tr key={imei}>
                {imei && <td className="border p-1">{imei}</td>}
                {device_id && <td className="border p-1">{device_id}</td>}
                {dispatch_date && (
                  <td className="border p-1">{dispatch_date}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        ""
      )}

      <div ref={loaderRef} />
    </div>
  );
}

export default Preview;
